<template>
  <div id="options">
    <Breadcrumbs v-bind="$attrs" :leg-index="legIndex" :hotels="hotels" @update:is-saved-route="$emit('update:isSavedRoute', $event)" @update:leg-index="$emit('update:legIndex', $event)" />
    <FilterSort v-if="selectedId == null" v-model:filter="filter" v-model:sort="sort" />
    <List v-show="selectedId == null" v-bind="$attrs" v-model:filter="filter" v-model:id="selectedId" v-model:sort="sort" :hotels="hotels" :leg-index="legIndex" :organization-id="organizationId" @reset-filter-sort="resetFilterSort" @error="$emit('error', $event)" @update:is-self-book="$emit('update:isSelfBook', $event)" />
    <Single v-if="selectedId != null" v-bind="$attrs" v-model:id="selectedId" :hotels="hotels" :leg-index="legIndex" :organization-id="organizationId" @error="$emit('error', $event)" @scroll="$emit('scroll', $event)" @update:hotels="$emit('update:hotels', $event)" @update:is-saved-hotels="$emit('update:isSavedHotels', $event)" @update:leg-index="$emit('update:legIndex', $event)" />
    <div id="navigation">
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Breadcrumbs from "./TripNewBookHotelsOptionsBreadcrumbs.vue";
import FilterSort from "./TripNewBookHotelsOptionsHotelsFilterSort.vue";
import List from "./TripNewBookHotelsOptionsList.vue";
import Single from "./TripNewBookHotelsOptionsSingle.vue";

const emit = defineEmits(["error", "scroll", "update:isSavedRoute", "update:legIndex", "update:hotels", "update:isSavedHotels", "update:isSelfBook"]);
defineProps(["hotels", "legIndex", "organizationId"]);

const filter = ref({ name: "", policy: false, review: 0, star: 0 });
const selectedId = ref(null);
const sort = ref("nearest");

// Methods
const back = () => {
  emit("update:isSavedRoute", false);
};

const resetFilterSort = () => {
  //prevent loop of death
  if (sort.value == "nearest" && filter.value.name == "" && filter.value.policy == false && filter.value.review == 0 && filter.value.star == 0) return;

  filter.value = { name: "", policy: false, review: 0, star: 0 };
  sort.value = "nearest";
};
</script>
